module.exports = __webpack_public_path__ + "static/media/barberapp.f7e14844.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/projetos/barberapp.png
// module id = 85
// module chunks = 0